import React, { useEffect } from "react";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import Footer from "../layouts/Footer";
import Header from "../layouts/Header";
import ThemeStoreLayout from "../layouts/ThemeStoreLayout";
import TestimonialSlider from "../components/TestimonialSlider/TestimonialSlider";
import usePageMeta from "../Helpers/usePageMeta";

const ThemeStore = () => {
  usePageMeta({
    title: "Theme Store | TZ Creation",
    description:
      "Pick a ready-made website theme from TZ Creation and quick-start your project.",
    path: "/theme-store",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Header />
      <Breadcrumb parentpageName="Home" currentPageName="Theme Store" />
      <ThemeStoreLayout />
      <TestimonialSlider />
      <Footer />
    </>
  );
};

export default ThemeStore;
